import { Suspense } from 'react';
import { Route, Routes } from 'react-router';

import WarningWrapper from '@/features/warnings/WarningWrapper';
import { LoadingIndicator } from './LoadingIndicator';

const MainComponent = () => (
    <div className="overflow-hidden display-flex flex-column padding-bottom-2">
        <Suspense fallback={<LoadingIndicator />}>
            <Routes>
                <Route path="/:assetId" element={<WarningWrapper />} />
            </Routes>
        </Suspense>
    </div>
);

export default MainComponent;
